/* structure.tsx generated by @compiled/babel-plugin v0.17.1 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import { atom, useAtom, useAtomValue } from "jotai";
import theme from "../theme";
import { SplitView, SplitViewCol } from "../components/split-view";
import JSONTree from "../components/json-tree";
import { Heading, HeadingWithButton, HeadingButton } from "../components/heading";
import { nodeColorsAtom } from "../state/node-colors";
import { editorStateAtom } from "../state/editor-state";
var _23 = "._19bvrdoj{padding-left:9px}";
var _22 = "._u5f3rdoj{padding-right:9px}";
var _21 = "._16jlkb7n{flex-grow:1}";
var _20 = "._o572qvpr{white-space:pre}";
var _19 = "._bfhk1kix{background-color:hsla(0,0%,100%,.3)}";
var _18 = "._19bvi2wt{padding-left:6px}";
var _17 = "._n3td1l7b{padding-bottom:3px}";
var _16 = "._u5f3i2wt{padding-right:6px}";
var _15 = "._ca0q1l7b{padding-top:3px}";
var _14 = "._d0altlke:hover{cursor:pointer}";
var _13 = "._11q71iim{background:var(--_1d6dlof)}";
var _12 = "._otyr1l7b{margin-bottom:3px}";
var _11 = "._1n261g80{flex-wrap:wrap}";
var _10 = "._1bsb1osq{width:100%}";
var _9 = "._1e0c1txw{display:flex}";
var _8 = "._1s7z104w{border-right:1px solid rgba(205,214,244,.2)}";
var _7 = "._1kl7104w{border-left:1px solid rgba(205,214,244,.2)}";
var _6 = "._vchhusvi{box-sizing:border-box}";
var _5 = "._19bv1crf{padding-left:9pt}";
var _4 = "._n3tdidpf{padding-bottom:0}";
var _3 = "._u5f31crf{padding-right:9pt}";
var _2 = "._ca0qidpf{padding-top:0}";
var _ = "._19pk1crf{margin-top:9pt}";
var GraphWrapper = function GraphWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_19pk1crf"])
  }, children));
};
var BlockNodeContentView = function BlockNodeContentView(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_2, _3, _4, _5, _6, _7, _8]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_ca0qidpf _u5f31crf _n3tdidpf _19bv1crf _vchhusvi _1kl7104w _1s7z104w"])
  }, children));
};
var BlockNodeContentViewWithInline = function BlockNodeContentViewWithInline(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_2, _3, _4, _5, _9, _10, _6, _7, _8, _11]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_ca0qidpf _u5f31crf _n3tdidpf _19bv1crf _1e0c1txw _1bsb1osq _vchhusvi _1kl7104w _1s7z104w _1n261g80"])
  }, children));
};
var BlockNodeView = function BlockNodeView(_ref4) {
  var children = _ref4.children,
    bg = _ref4.bg,
    onClick = _ref4.onClick;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_10, _12, _6, _9, _13, _14]), /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    className: ax(["_1bsb1osq _otyr1l7b _vchhusvi _1e0c1txw _11q71iim _d0altlke"]),
    style: {
      "--_1d6dlof": ix(bg)
    }
  }, children));
};
var Side = function Side(_ref5) {
  var tooltip = _ref5.tooltip,
    children = _ref5.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_15, _16, _17, _18, _19]), /*#__PURE__*/React.createElement("div", {
    title: tooltip,
    className: ax(["_ca0q1l7b _u5f3i2wt _n3td1l7b _19bvi2wt _bfhk1kix"])
  }, children));
};
var StartSide = function StartSide(_ref6) {
  var children = _ref6.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_15, _16, _17, _18, _20]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_ca0q1l7b _u5f3i2wt _n3td1l7b _19bvi2wt _o572qvpr"])
  }, children));
};
var Bar = function Bar(_ref7) {
  var children = _ref7.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_21]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_16jlkb7n"])
  }, children));
};
var Center = function Center(_ref8) {
  var children = _ref8.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_21, _15, _22, _17, _23, _20]), /*#__PURE__*/React.createElement("div", {
    className: ax(["_16jlkb7n _ca0q1l7b _u5f3rdoj _n3td1l7b _19bvrdoj _o572qvpr"])
  }, children));
};
var InlineNodeView = function InlineNodeView(_ref9) {
  var children = _ref9.children,
    bg = _ref9.bg,
    onClick = _ref9.onClick;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_21, _12, _9, _6, _13, _14]), /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    className: ax(["_16jlkb7n _otyr1l7b _1e0c1txw _vchhusvi _11q71iim _d0altlke"]),
    style: {
      "--_1d6dlof": ix(bg)
    }
  }, children));
};
export function BlockNodeContent(props) {
  var fragment = props.content;
  if (!fragment || !fragment.content || !fragment.content.length) {
    return null;
  }
  var content = fragment.content;
  if (content[0].isBlock) {
    var _startPos = props.startPos + 1;
    return /*#__PURE__*/React.createElement(BlockNodeContentView, null, content.map(function (childNode, index) {
      var pos = _startPos;
      _startPos += childNode.nodeSize;
      return /*#__PURE__*/React.createElement(BlockNode, {
        key: index,
        node: childNode,
        colors: props.colors,
        onNodeSelected: props.onNodeSelected,
        startPos: pos
      });
    }));
  }
  var startPos = props.startPos;
  return /*#__PURE__*/React.createElement(BlockNodeContentViewWithInline, null, content.map(function (childNode, index) {
    var pos = startPos;
    startPos += childNode.nodeSize;
    return /*#__PURE__*/React.createElement(InlineNode, {
      key: index,
      index: index,
      node: childNode,
      bg: props.colors[childNode.type.name],
      onNodeSelected: props.onNodeSelected,
      startPos: pos
    });
  }));
}
export function BlockNode(props) {
  var colors = props.colors,
    node = props.node,
    startPos = props.startPos;
  var color = colors[node.type.name];
  var marks = getMarksText(node);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BlockNodeView, {
    bg: color,
    onClick: function onClick() {
      return props.onNodeSelected({
        node: node
      });
    }
  }, startPos > 0 && /*#__PURE__*/React.createElement(Side, {
    tooltip: "Pos: ".concat(startPos - 1, " (before ").concat(node.type.name, " opening tag)")
  }, startPos - 1), /*#__PURE__*/React.createElement(StartSide, null, node.type.name, " ", marks), /*#__PURE__*/React.createElement(Side, {
    tooltip: "Pos: ".concat(startPos, " (after ").concat(node.type.name, " opening tag)")
  }, startPos), /*#__PURE__*/React.createElement(Bar, null), /*#__PURE__*/React.createElement(Side, {
    tooltip: "Pos: ".concat(startPos + node.nodeSize - 1, " (after ").concat(node.type.name, " closing tag)")
  }, startPos + node.nodeSize - 1)), /*#__PURE__*/React.createElement(BlockNodeContent, {
    content: node.content,
    colors: colors,
    onNodeSelected: props.onNodeSelected,
    startPos: startPos
  }));
}
export function InlineNode(props) {
  var node = props.node,
    bg = props.bg,
    startPos = props.startPos,
    index = props.index;
  var marks = getMarksText(node);
  return /*#__PURE__*/React.createElement(InlineNodeView, {
    onClick: function onClick() {
      return props.onNodeSelected({
        node: node
      });
    },
    bg: bg
  }, index === 0 ? /*#__PURE__*/React.createElement(Side, {
    tooltip: "Pos: ".concat(startPos, " (before ").concat(node.type.name, " opening tag)")
  }, startPos) : null, /*#__PURE__*/React.createElement(Center, null, node.type.name, " ", marks), /*#__PURE__*/React.createElement(Bar, null), /*#__PURE__*/React.createElement(Side, {
    tooltip: "Pos: ".concat(startPos + node.nodeSize, " (before ").concat(node.type.name, " closing tag)")
  }, startPos + node.nodeSize));
}
var structureTabSelectedNode = atom(null);
export default function GraphTab() {
  var _useAtom = useAtom(structureTabSelectedNode),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    selectedNode = _useAtom2[0],
    setSelectedNode = _useAtom2[1];
  var handleNodeSelect = React.useCallback(function (_ref10) {
    var node = _ref10.node;
    return setSelectedNode(node);
  }, []);
  var nodeColors = useAtomValue(nodeColorsAtom);
  var state = useAtomValue(editorStateAtom);
  if (!state) return null;
  var selected = selectedNode ? selectedNode : state.doc;
  return /*#__PURE__*/React.createElement(SplitView, {
    testId: "__prosemirror_devtools_tabs_structure__"
  }, /*#__PURE__*/React.createElement(SplitViewCol, {
    grow: true
  }, /*#__PURE__*/React.createElement(Heading, null, "Current Doc"), /*#__PURE__*/React.createElement(GraphWrapper, null, /*#__PURE__*/React.createElement(BlockNode, {
    colors: nodeColors,
    node: state.doc,
    startPos: 0,
    onNodeSelected: handleNodeSelect
  }))), /*#__PURE__*/React.createElement(SplitViewCol, {
    sep: true,
    minWidth: 200,
    maxWidth: 300
  }, /*#__PURE__*/React.createElement(HeadingWithButton, null, /*#__PURE__*/React.createElement(Heading, null, "Node Info"), /*#__PURE__*/React.createElement(HeadingButton, {
    onClick: function onClick() {
      return console.log(selected);
    }
  }, "Log Node")), /*#__PURE__*/React.createElement(JSONTree, {
    data: selected.toJSON(),
    hideRoot: true,
    shouldExpandNode: function shouldExpandNode() {
      return selected.type.name !== "doc" ? true : false;
    }
  })));
}
function getMarksText(node) {
  return node.marks.length === 1 ? " - [".concat(node.marks[0].type.name, "]") : node.marks.length > 1 ? " - [".concat(node.marks.length, " marks]") : "";
}